export const DROPPABLE_ELEMENT_TYPES = {
  CARD_ELEMENT_PHOTO: 'CARD_ELEMENT_PHOTO',
  SLIDESHOW_SECONDARY_CONTROL: 'SLIDESHOW_SECONDARY_CONTROL',
  MANUAL_MATCHING_PHOTO_GRID_CARD: 'MANUAL_MATCHING_PHOTO_GRID_CARD',
};
